import * as dealHelpers from 'resources/deal/deal.helpers';

import {
  USER_TYPES, USER_STATUSES, CLIENT_ROLES, DEALS_STATUSES,
} from './user.constants';

const isDeactivated = (user) => user && !!user.is_deactivated;

const isTypeNotDefined = (user) => user && !user.type;
const isRealtor = (user) => user && user.type === USER_TYPES.REALTOR;
const isCoordinator = (user) => user && user.type === USER_TYPES.COORDINATOR;
const isAdmin = (user) => user && user.type === USER_TYPES.ADMIN;
const isCoordinatorOrAdmin = (user) => isCoordinator(user) || isAdmin(user);
const isClient = (user) => user && user.type === USER_TYPES.CLIENT;

const isManager = (user) => user && (isTypeNotDefined(user) || isRealtor(user) || isCoordinator(user) || isAdmin(user));

const isNewLead = (user) => isClient(user)
  && user.deals_status !== DEALS_STATUSES.INACTIVE
  && user.roles?.includes(CLIENT_ROLES.NEW_LEAD);

const isInvited = (user) => user?.status === USER_STATUSES.INVITED;
const isNotInvited = (user) => user?.status === USER_STATUSES.NOT_INVITED;
const isRegistered = (user) => user?.status === USER_STATUSES.REGISTERED;

const getRealtorTitle = (realtor) => {
  const realtorTitle = realtor?.type_data?.realtor_title;

  if (!realtorTitle) {
    return null;
  }

  return realtorTitle === 'Realtor' ? 'Realtor®' : realtorTitle;
};

const getRealtorTitleInfo = ({ title, companyName }) => {
  if (title && companyName) {
    return `${title}/${companyName}`;
  }

  if (title) {
    return title;
  }

  if (companyName) {
    return companyName;
  }

  return null;
};

const sortUsersByStatusSequence = (users, statuses) => {
  if (!users || !statuses) return [];

  return statuses.flatMap((status) => users.filter((user) => user.status === status));
};

export const isSampleClient = (user) => isClient(user) && user.app_state?.is_sample;

const isMySampleClient = ({ client, realtorId }) => client.realtor_ids?.includes(realtorId) && isSampleClient(client);

const filterSampleClients = ({ clients, realtorId, deals }) => {
  if (!clients?.length) {
    return [];
  }

  const filteredDeals = dealHelpers.filterSampleDeals({ deals, realtorId });
  const sampleDeals = filteredDeals.filter((d) => d.is_sample);

  const clientsWithoutSample = clients.filter((client) => !isSampleClient(client));

  if (clientsWithoutSample.length > 0 && sampleDeals.length === 0) {
    return clientsWithoutSample;
  }

  const mySampleClients = clients.filter((client) => isMySampleClient({ client, realtorId })
    || !isSampleClient(client));

  return mySampleClients;
};

const getFullName = (user) => {
  if (!user) {
    return null;
  }

  return user.first_name ? `${user.first_name.trim()} ${user.last_name.trim()}` : user.email;
};

const getClientFirstNames = (clients) => clients?.map((client) => client.first_name).join(', ');

const getClientFullNames = (clients) => clients?.map((client) => `${client.first_name} ${client.last_name}`).join(', ');

export {
  isDeactivated,

  isTypeNotDefined,
  isRealtor,
  isCoordinator,
  isAdmin,
  isCoordinatorOrAdmin,
  isClient,

  isManager,

  isNewLead,

  isInvited,
  isNotInvited,
  isRegistered,

  getRealtorTitle,
  getRealtorTitleInfo,

  sortUsersByStatusSequence,

  filterSampleClients,

  getFullName,
  getClientFirstNames,
  getClientFullNames,
};
